import { Injectable } from '@angular/core';
import { ProjectTab } from 'app/shared/models/project/Project-Tab';

export interface ProjectValidate {
  header: boolean;
  parameters: boolean;
  assetmapping: boolean;
  team: boolean;
  accounting: boolean;
}

export interface ProjectSchemas {
  project: ProjectTab;
  validate: ProjectValidate;
  status: string;
  team?: any;
}

export interface ProjectData {
  [key: string]: ProjectSchemas;
}

@Injectable()
export class ProjectState {
  public _data: ProjectData = {};

  public get data() {
    return this._data;
  }

  public set data(value: any) {
    throw new Error('do not mutate the `.state` directly' + value);
  }

  public get(object?: string) {
    const state = this.data;
    return state.hasOwnProperty(object) ? state[object] : state;
  }

  public set(category: string, value: any) {
    return this._data[category] = value;
  }
}